import { CatMark } from "./Doodles";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative bg-[#2B0A4E] text-[#FDFBF5] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="bg-[#FDFBF5] rounded-full p-2">
                <CatMark className="h-10 w-auto" />
              </span>
              <span className="font-serif-display font-bold text-2xl tracking-[0.15em]">KATZYA</span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-[#FDFBF5]/70 leading-relaxed">
              {t("footer_tag")}
            </p>
          </div>
          <div className="flex flex-wrap gap-x-10 gap-y-3 font-mono-label text-sm tracking-[0.2em] uppercase text-[#FDFBF5]/70">
            <a data-testid="footer-email" href="mailto:info@katzya.de" className="hover:text-[#F2C230] transition-colors">Email</a>
            <a data-testid="footer-instagram" href="https://instagram.com/offical.katzya" target="_blank" rel="noreferrer" className="hover:text-[#F2C230] transition-colors">Instagram</a>
            <a data-testid="footer-phone" href="tel:+4915755849826" className="hover:text-[#F2C230] transition-colors">{t("footer_call")}</a>
          </div>
        </div>

        <p className="font-serif-display font-bold text-[18vw] leading-none text-center select-none text-[#FDFBF5]/[0.06] mt-10 -mb-6" aria-hidden="true">
          KATZYA
        </p>

        <div className="relative border-t border-[#FDFBF5]/15 pt-6 mt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#FDFBF5]/50">
          <span>© {new Date().getFullYear()} KATZYA. {t("footer_rights")}</span>
          <span className="font-mono-label tracking-[0.2em] uppercase">{t("footer_made")}</span>
        </div>
      </div>
    </footer>
  );
}
